export default "__VITE_ASSET__BVGDpGF8__"